import { subDays, startOfDay } from "date-fns";

export const BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api`;

export const ENDPOINT = "colors-of-water-elkhead";

export const DEFAULT_QUERY_OPTIONS = {
  keepPreviousData: false,
  refetchOnWindowFocus: false,
  staleTime: Infinity,
  cacheTime: Infinity,
};

export const TIME_INTERVAL_OPTIONS = [
  {
    label: "Daily Data",
    value: "daily",
  },
];

export const DEFAULT_TIME_INTERVAL = TIME_INTERVAL_OPTIONS[0].value;

const START_DAYS_AGO = 90;

export const DEFAULT_START_DATE = startOfDay(
  subDays(new Date(), START_DAYS_AGO)
);
export const DEFAULT_END_DATE = startOfDay(new Date());

export const DATE_FORMAT = "MMM dd yyyy";

export const TIMESERIES_AXIS_DATE_FORMAT = "MM/DD/yyyy";

const today = startOfDay(new Date()); // 00:00 local
const FIRST_OF_YEAR = new Date(today.getFullYear(), 0, 1);

export const QUICKSET_OPTIONS = [
  { label: "Year to Date", calculateStartDate: () => FIRST_OF_YEAR },

  {
    label: "Last 7 Days",
    calculateStartDate: () => startOfDay(subDays(today, 7)),
  },
  {
    label: "Last 30 Days",
    calculateStartDate: () => startOfDay(subDays(today, 30)),
  },
  {
    label: "Last 90 Days",
    calculateStartDate: () => startOfDay(subDays(today, 90)),
  },
  {
    label: "Last 180 Days",
    calculateStartDate: () => startOfDay(subDays(today, 180)),
  },
  {
    label: "Last 365 Days",
    calculateStartDate: () => startOfDay(subDays(today, 365)),
  },
];
